<template>
    <SideFormSection>
        <template #title> Services </template>
        <template #rawContent>
            <Card
                title="Services"
                iconName="box"
            >
                <template #content>
                    <CompanyUserServiceTable
                        :origin="origin"
                        :companyUserAggregate="companyUserAggregate"
                        :services="services"
                    />
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
    import CompanyUserServiceTable from '@/App/CompanyUser/Component/CompanyUserServiceTable.vue'
    import Service from '@/App/Service/Entity/Service'
    import type { EditServiceOriginEnum } from '@/Shared/AutoGenerated/Main'

    const props = defineProps({
        companyUserAggregate: {
            type: Object as PropType<CompanyUserAggregate>,
            required: true,
        },
        services: {
            type: Array as PropType<Service[]>,
            required: true,
        },
        origin: {
            type: String as PropType<EditServiceOriginEnum>,
            required: true,
        },
    })
</script>
